import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectAllOffersLink, selectOffersCount } from 'shared/selectors/offers';
import { trackAllOffersLinkClick } from '../../tracking';
import { AllOffersLinkButton } from 'shared/components/AllOffersLinkButton';

export const AllOffersLinkButtonContainer = () => {
  const allOffersLink = useSelector(selectAllOffersLink);
  const offersCount = useSelector(selectOffersCount);

  const onAllOffersLinkClick = useCallback(() => {
    trackAllOffersLinkClick(offersCount);
  }, [offersCount]);

  if (!allOffersLink) {
    return null;
  }

  return <AllOffersLinkButton link={allOffersLink} onClick={onAllOffersLinkClick} />;
};
